import { BuildInstruction } from './types';

export const KWH_01_01: BuildInstruction = {
    id: 'kwh-01-01',
    productName: 'Kibu Wired Headphones',
    productCode: 'KWH-01-01',
    introduction: {
        id: 'introduction',
        title: 'Introduction to Kibu Headphone Assembly',
        description: 'Welcome to the Kibu build experience! This introduction guides you through the simple steps to assemble your Kibu Headphones. Each step is designed to be easy to follow and ensures your headphones are built correctly.',
        videoUrl: 'https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_introduction.m3u8',
        duration: '0:18',
        completed: false
    },
    steps: [
        {
            id: "step-1",
            title: "Unpack Electronics",
            description: "Open the box and remove the electronics from Door 1. You'll find two round speakers with metal grills and two black main boards marked with left/right arrows. The main boards have black headers on the bottom side.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_1.m3u8",
            duration: "0:23",
            completed: false
        },
        {
            id: "step-2",
            title: "Connect First Speaker",
            description: "Connect the first speaker to its main board. Place the speaker with the metal grill facing down and headers pointing up. Align the right arrow on the main board with the signal arrow on the speaker, then insert the four pins carefully.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_2.m3u8",
            duration: "0:46",
            completed: false
        },
        {
            id: "step-3",
            title: "Connect Second Speaker",
            description: "Connect the second speaker to its main board. Align the left arrow on the main board with the signal arrow on the speaker, then insert the four pins with care.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_3.m3u8",
            duration: "0:20",
            completed: false
        },
        {
            id: "step-4",
            title: "Non-Electronic Parts",
            description: "Open Door 2 to access the non-electronic components. Remove the two inner parts (flat surfaces with grills) and the soft round ear cushions.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_4.m3u8",
            duration: "0:16",
            completed: false
        },
        {
            id: "step-5",
            title: "Attach First Cushion",
            description: "Attach the first cushion to an inner part. The cushion has a small hole for your ear and a larger cutout on the other side. Feed the inner part into the gap and slide the cushion around the circumference, stretching slightly as needed.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_5.m3u8",
            duration: "0:30",
            completed: false
        },
        {
            id: "step-6",
            title: "Attach Second Cushion",
            description: "Repeat the process with the second cushion and inner part. Carefully slide the inner part into the cushion all the way around.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_6.m3u8",
            duration: "0:15",
            completed: false
        },
        {
            id: "step-7",
            title: "Insert Speaker Assembly",
            description: "Insert the speaker and main board assembly into each inner part. Position the speaker facing down toward the grill. Align the main board's arrows with the flat sides of the inner part.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_7.m3u8",
            duration: "0:30",
            completed: false
        },
        {
            id: "step-8",
            title: "Attach First Clip",
            description: "Get the clips from Door 2. Align the protruding parts of the first clip with the slots on the main board, then slide it over the main board onto the ridged alignment sections.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_8.m3u8",
            duration: "0:25",
            completed: false
        },
        {
            id: "step-9",
            title: "Attach Second Clip",
            description: "Attach the second clip in the same manner, sliding it carefully over the main board and onto the other ridge section.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_9.m3u8",
            duration: "0:11",
            completed: false
        },
        {
            id: "step-10",
            title: "Add First Middle Donut",
            description: "Get the middle donuts from Door 2. Align the guiding sides of the first middle donut with the clip, then press it down until it rests on the cushion.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_10.m3u8",
            duration: "0:20",
            completed: false
        },
        {
            id: "step-11",
            title: "Add Second Middle Donut",
            description: "Repeat for the second headphone cup, aligning the middle donut with the clip using the guide shape as reference.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_11.m3u8",
            duration: "0:12",
            completed: false
        },
        {
            id: "step-12",
            title: "Connect First Aux Links",
            description: "Get the Kibu Aux Links from Door 1. Press down on the middle donut to compress the cushion, then plug the aux link into the main board's middle headers. The pins should face up toward you.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_12.m3u8",
            duration: "1:02",
            completed: false
        },
        {
            id: "step-13",
            title: "Connect Second Aux Links",
            description: "Repeat the process with the remaining two aux links for the second headphone cup.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_13.m3u8",
            duration: "0:20",
            completed: false
        },
        {
            id: "step-14",
            title: "Attach First Outer Donut",
            description: "Get the outer donuts from Door 2. Align the first outer donut's cutout with the clip, then press it down by pushing with two fingers on the sides where the aux links are located.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_14.m3u8",
            duration: "0:34",
            completed: false
        },
        {
            id: "step-15",
            title: "Attach Second Outer Donut",
            description: "Repeat for the second headphone cup, aligning the outer donut's cutout with the clip and pressing down on the correct sides.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_15.m3u8",
            duration: "0:20",
            completed: false
        },
        {
            id: "step-16",
            title: "Prepare Headband",
            description: "Get the headband and cushion from Door 2, and the shortest cable from Door 1. Unwind the cable so it's ready to use.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_16.m3u8",
            duration: "0:16",
            completed: false
        },
        {
            id: "step-17",
            title: "Attach First Cushion Section",
            description: "Insert the first cushion section into one end of the headband by pushing it into the lowest gap. Work around the headband pressing the cushion into place until it's completely seated.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_17.m3u8",
            duration: "0:40",
            completed: false
        },
        {
            id: "step-18",
            title: "Attach Second Cushion Section",
            description: "Flip the headband over and work around to pull the second cushion section over the headband.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_18.m3u8",
            duration: "0:09",
            completed: false
        },
        {
            id: "step-19",
            title: "Insert Headband Cable",
            description: "Feed the unwound headband cable into the space between the cushion and headband, avoiding the internal gap.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_19.m3u8",
            duration: "0:19",
            completed: false
        },
        {
            id: "step-20",
            title: "Complete Cushion Installation",
            description: "Slide the remaining cushion section into the headband gap. Push one corner in first, then work around the headband. You may need to gently stretch the headband near the end for the cushion to fit properly.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_20.m3u8",
            duration: "0:30",
            completed: false
        },
        {
            id: "step-21",
            title: "Attach Headphone Cups",
            description: "Rotate the cups so the logo box faces upward, then carefully slide the headband onto them.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_21.m3u8",
            duration: "0:24",
            completed: false
        },
        {
            id: "step-22",
            title: "Connect Headband Cables",
            description: "Connect the headband cables into the cups. The metal from the cable should not be visible when fully plugged in.",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_22.m3u8",
            duration: "0:11",
            completed: false
        },
        {
            id: "step-23",
            title: "Connect Device Cable",
            description: "Get the longer device cable from Door 1 and unwind it. This cable can be attached to either side and allows for daisy-chaining additional headphones. Connect it to your audio device and enjoy your music!",
            videoUrl: "https://d1tg5gdu842vo5.cloudfront.net/instructions/KWH-01-01/older/1080p/v1_2_step_23.m3u8",
            duration: "0:24",
            completed: false
        }
    ],
    metadata: {
        totalDuration: '9:58',
        difficulty: 'beginner',
        toolsRequired: ['None - all tools provided'],
        estimatedTime: '20-30 minutes'
    }
};